/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BookingPriceBandInput
 */
export interface BookingPriceBandInput {
    /**
     * 
     * @type {number}
     * @memberof BookingPriceBandInput
     */
    markupAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof BookingPriceBandInput
     */
    markupPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof BookingPriceBandInput
     */
    max?: number;
    /**
     * 
     * @type {number}
     * @memberof BookingPriceBandInput
     */
    min?: number;
}

export function BookingPriceBandInputFromJSON(json: any): BookingPriceBandInput {
    return BookingPriceBandInputFromJSONTyped(json, false);
}

export function BookingPriceBandInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingPriceBandInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'markupAmount': !exists(json, 'markupAmount') ? undefined : json['markupAmount'],
        'markupPercentage': !exists(json, 'markupPercentage') ? undefined : json['markupPercentage'],
        'max': !exists(json, 'max') ? undefined : json['max'],
        'min': !exists(json, 'min') ? undefined : json['min'],
    };
}

export function BookingPriceBandInputToJSON(value?: BookingPriceBandInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'markupAmount': value.markupAmount,
        'markupPercentage': value.markupPercentage,
        'max': value.max,
        'min': value.min,
    };
}


